import CustomText from './CustomText';
import {CustomTextProps} from './type';
import Font from '../../../appStyles/style/font';
import React from 'react';

import {StyleSheet, Text} from 'react-native';
import {useFontTheme} from '../../../appStyles/hooks/theme';

const H4Text: React.FC<CustomTextProps<Text>> = React.forwardRef(
  (props, ref) => {
    const fontTheme = useFontTheme(props.fontTheme || 'muli');
    const propsToSpread = {
      ...props,
      style: [styles.H4Text, {fontFamily: fontTheme[700].normal}, props.style],
    };

    return (
      <CustomText ref={ref} {...propsToSpread}>
        {props.children}
      </CustomText>
    );
  },
);

const styles = StyleSheet.create({
  H4Text: {
    ...Font.FontSize.fontH4,
  },
});

export default React.memo(H4Text);
